import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BeneListService } from '../../../../services/beneList.service';
import { ModalRouteService } from '../../../../services/modal-route.service';
import { BeneFormOtherTrustComponent } from '../bene-form.other-trust.component';
import { CommonGuiPart } from '../../commonGuiPart';
import { CityListService } from '../../../../../../common/services/cityList.service';

@Component({
  selector: 'bene-form-other-trust-coverpath',
  templateUrl: './bene-form.other-trust.component.coverpath.html',
})
export class BeneFormOtherTrustComponentCoverPath extends BeneFormOtherTrustComponent {
  isZipLoading: boolean = false;
  constructor(
    beneListService: BeneListService,
    modalRouteService: ModalRouteService,
    router: Router,
    activatedRouter: ActivatedRoute,
    fb: FormBuilder
  ) {
    super(beneListService, modalRouteService, router, activatedRouter, fb);
  }

  async zipCodeLookup(): Promise<void> {
    this.isZipLoading = true;
    const cityListService: CityListService = await CommonGuiPart.getLocObjByZipCode(
      this.beneForm.get('zip').value,
      this.beneListService,
      CityListService.CHANNEL_COVERPATH
    );
    if (cityListService) {
      this.beneForm.get('city').setValue(cityListService.getCity());
      this.beneForm.get('state').setValue(cityListService.getStateCode());
    } else {
      this.beneForm.get('zip').setErrors({ unsupportedZip: true });
    }
    this.isZipLoading = false;
  }
}
